import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const ProductsAvailabilitySelectors = createBasicSelectors('productsAvailability')

export default ProductsAvailabilitySelectors
